var blInventoryCSV = {
    status : 0 /* 0: ok, 1: empty, 2: file error */
,   itemCnt: 0
,   totalItemQty: 0
    ,   initData: function() {
        this.status = 0;
        this.itemCnt = 0;
        this.totalItemQty = 0;
    }
,   loadFile: function(file, callback) {
        let reader = new FileReader();
        let that = this;

        this.initData();

        reader.readAsText(file);
        reader.onload = function() {
            that.readData(reader.result);
            callback("csv");
        };
    }
,   readData: function(strCSV) {
        var array = strCSV.toString().split(/\r?\n/);
        let listItem = [];
        let headers = array[0].split(",")
        for (let i = 1; i < array.length - 1; i++) {
            let obj = {};
            let str = array[i];
            let s = '';
            let flag = 0;
      
            for (let ch of str) {
                if (ch === '"' && flag === 0) {
                    flag = 1;
                }
                else if (ch === '"' && flag == 1) flag = 0;
                if (ch === ',' && flag === 0) ch = '|';
                if (ch !== '"') s += ch;
            }
            let properties = s.split("|");

            for (let j in headers) {
                if (typeof properties[j] != "undefined")
                {
                    if (properties[j].includes(",")) {
                        obj[headers[j]] = properties[j].split(",").map(item => item.trim());
                    }
                    else obj[headers[j]] = properties[j];
            
                }
            }
            listItem.push(obj)
        }

        for (const item of listItem) {
            if (item["Quantity"] > 0) {
                this.totalItemQty += parseInt(item["Quantity"]);
            }
            else if (item["Qty owned"] > 0) {
                this.totalItemQty += parseInt(item["Qty owned"]);
            }
            else if (item["QtyOwned"] > 0) {
                this.totalItemQty += parseInt(item["QtyOwned"]);
            }
        }

        if (this.totalItemQty == 0) {
            this.status = 1;
        }
        
    }
,   getStatus: function() {
        return this.status;
    }
,   getTotalItemQty: function() {
        return this.totalItemQty;
    }
,   isEmpty: function() {
        return true;
    }
};

var	blInventoryXML	= {
    status : 0 /* 0: ok, 1: empty, 2: file error */
,   itemCnt: 0
,   totalItemQty: 0
,   initData: function() {
    this.status = 0;
    this.itemCnt = 0;
    this.totalItemQty = 0;
    }
,   loadFile: function(file, callback) {
		let reader = new FileReader();
        let that = this;

        this.initData();
        
		reader.readAsText(file);
		reader.onload = function() {
            that.readData(reader.result);
            callback("xml");
        };
    }
,   readData: function(strXML) {
        const parser = new DOMParser();
        const xlmDoc = parser.parseFromString(strXML, "application/xml");
        const errorNode = xlmDoc.querySelector("parsererror");
        let cntItemQty = 0;
        
        if (errorNode) {
            this.status = 2;
        } else {
            let items = xlmDoc.getElementsByTagName("ITEM");
            if (items.length == 0) 
            {
                this.status = 1; // Empty 
            }
            else
            {
                for (const item of items) {
                    cntItemQty += parseInt(item.getElementsByTagName("QTY")[0].textContent);
                }
                if (cntItemQty == 0) 
                    this.status = 1;
                else 
                    this.status = 0;
            }
            this.totalItemQty = cntItemQty;
        }
    }
,   getStatus: function() {
        return this.status;
    }
,   getTotalItemQty: function() {
        return this.totalItemQty;
    }
,   isEmpty: function() {
        return true;
    }
};

export default {blInventoryXML, blInventoryCSV};